<template>
    <x-container v-if="!loading" fluid class="additional-information-container pa-0">
        <x-layout wrap>
            <x-flex
                v-for="(section, index) in value"
                :key="`information-section-${index}`"
                xs12
                class="right"
            >
                <x-card class="panel mb-5">
                    <x-card-title>
                        <x-container fluid class="pa-0">
                            <x-layout>
                                <x-flex>
                                    <h3>{{ section.name }}</h3>
                                </x-flex>

                                <template v-if="section.permissions">
                                    <x-flex v-if="section.insurer_company_ids.length === 1" class="grow-0">
                                        Viewable by:

                                        <span class="secondary--text">{{ getInsurerName(section.permissions[0]) }}</span>
                                    </x-flex>

                                    <x-flex v-else class="grow-0">
                                        Viewable by:

                                        <span class="secondary--text insurer-permissions" @click="openPermissionsModal(section)">
                                            {{ numberOfInsurersSelected(section.insurer_company_ids) }}
                                        </span>
                                    </x-flex>
                                </template>
                            </x-layout>
                        </x-container>
                    </x-card-title>

                    <x-card-text>
                        <div class="text-editor-output" v-html="section.content" />
                    </x-card-text>
                </x-card>
            </x-flex>
        </x-layout>

        <modal
            v-if="!insurer"
            ref="permissionsModal"
            :title="activeSection.name"
        >
            <p><strong>This section is viewable to the following insurers:</strong></p>

            <ul>
                <li v-for="(permission, index) in activeSection.permissions" :key="`permission-insurer-${index}`">{{ getInsurerName(permission) }}</li>
            </ul>
        </modal>
    </x-container>
</template>

<script>
import Modal from '~/components/Shared/UIComponents/Modal';

export default {
    name: 'AdditionalInformationTab',
    components: {
        Modal
    },
    props: {
        value: Array,
        facilityId: Number,
        insurerList: Array,
        insurer: Boolean,
    },
    data() {
        return {
            loading: true,
            insurers: [],
            activeSection: {},
        }
    },
    mounted() {
        this.getInsurers();
    },
    methods: {
        async getInsurers() {
            if (!this.insurer) {
                if (this.insurerList && this.insurerList.length > 0) {
                    this.insurers = this.insurerList;
                } else {
                    const url = this.facilityId ? `/api/insurer/facility/${this.facilityId}/captive/` : '/api/insurer';
                    await axios.get(url).then(res => {
                        this.insurers = res.data.data;
                    });
                }

                this.initialiseSections();
            }

            this.loading = false;
        },
        initialiseSections() {
            const insurerList = this.insurers;
            this.value.forEach(section => {
                if (!section.permissions && section.insurer_company_ids && insurerList) {
                    section.permissions = section.insurer_company_ids.map(insurerId => {
                        return {
                            insurer_company_id: insurerId,
                            insurer_company: insurerList.find(insurer => insurer.id === insurerId)
                        };
                    });
                } else if (section.permissions) {
                    section.insurer_company_ids = section.permissions.map(permission => permission.insurer_company_id).filter(insurerId => {
                        return insurerList.find(insurer => insurer.id === insurerId);
                    });
                }

                this.$set(section, 'show_all_insurers', false);
            });
        },
        numberOfInsurersSelected(selectedInsurers) {
            if (this.insurers.length === selectedInsurers.length) {
                return 'All insurers';
            }

            return selectedInsurers.length + ' insurers';
        },
        getInsurerName(permission) {
            return permission.insurer_company?.name || permission.captive_insurer_company?.name || '';
        },
        async openPermissionsModal(section) {
            this.activeSection = section;
            await this.$refs.permissionsModal.open();
        },
    }
}
</script>

<style lang="scss" scoped>
.additional-information-container {
    > .layout {
        display: block;
        column-count: 2;
        column-gap: 0;

        > .flex {
            break-inside: avoid-column;
        }
    }

    span.insurer-permissions {
        text-decoration: underline;
        cursor: pointer;
    }
}
</style>
